module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou8-a896a5d0e9fbfbd6121e1bf685b39df6.jpg";